// react
import { ReactNode, useContext, useState } from 'react';

// types
import { ExpenseType } from '../../../@types';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// context
import { ContextUserEntity } from '../../../App.context';
import { ContextProject } from '../../pages/Project/Project.context';

// mui
import { SelectChangeEvent } from '@mui/material';

// fields
import { Select, SelectProps } from '../Select/Select';

// props
export type SelectExpenseTypeProps = Omit<SelectProps, 'options'>;

export const SelectExpenseType = ({ onChange, ...props }: SelectExpenseTypeProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// context
	const { project } = useContext(ContextProject);
	const { userEntity } = useContext(ContextUserEntity);

	// state
	const [expenseTypes, setExpenseTypes] = useState<ExpenseType[]>([]);
	const [value, setValue] = useState(props.value as string);

	// fetch expense types
	let urlFetchExpenseTypes = `${process.env.REACT_APP_API_URL}/expense-types?project=${project?.id}&status=ACTIVE&orderBy=name&order=ASC`;

	// Use the entity from context
	if (userEntity) {
		urlFetchExpenseTypes += `&entity=null,${userEntity.id}`;
	}

	// fetch expense types
	useFetch({
		isEnabled: Boolean(project?.id),
		url: urlFetchExpenseTypes,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setExpenseTypes(res.data);
			}
		},
	});

	const handleChange = (e: SelectChangeEvent<unknown>, child: ReactNode) => {
		const value = e.target.value as string;

		if (onChange) {
			onChange(e, child);
		}

		setValue(value);
	};

	const optionsExpenseTypes = expenseTypes.map((expenseType) => {
		return {
			label: expenseType.name,
			MenuItemProps: {
				resource: expenseType,
			},
			value: String(expenseType.id),
		};
	});

	return (
		<Select
			name="expenseType"
			{...props}
			options={optionsExpenseTypes}
			onChange={handleChange}
			value={value}
		/>
	);
};
